var p = {
  prescriptionRequest: {
    doctor: {
      fullName: "",
      zsr: "",
      city: void 0,
      email: void 0,
      gln: void 0,
      phone: void 0,
      street: void 0,
      zipCode: void 0
    },
    medicines: [],
    permanentPrescription: !1,
    deliveryType: null,
    note: "",
    intendedType: null
  },
  preselectedMedicines: [],
  doctorPreferences: []
}, s = (r) => ({
  setDoctorData: (i) => r((e) => ({ prescriptionRequest: {
    ...e.prescriptionRequest,
    prescriptionRequest: {
      ...e.prescriptionRequest.prescriptionRequest,
      doctor: i
    }
  } })),
  setPreselectedMedicines: (i) => r((e) => ({ prescriptionRequest: {
    ...e.prescriptionRequest,
    preselectedMedicines: i,
    prescriptionRequest: {
      ...e.prescriptionRequest.prescriptionRequest,
      medicines: []
    }
  } })),
  setRequestId: (i) => r((e) => ({ prescriptionRequest: {
    ...e.prescriptionRequest,
    prescriptionRequest: {
      ...e.prescriptionRequest.prescriptionRequest,
      id: i
    }
  } })),
  setNote: (i) => r((e) => ({ prescriptionRequest: {
    ...e.prescriptionRequest,
    prescriptionRequest: {
      ...e.prescriptionRequest.prescriptionRequest,
      note: i
    }
  } })),
  addMedicine: (i) => r((e) => ({ prescriptionRequest: {
    ...e.prescriptionRequest,
    preselectedMedicines: [],
    prescriptionRequest: {
      ...e.prescriptionRequest.prescriptionRequest,
      medicines: [...e.prescriptionRequest.prescriptionRequest.medicines, i]
    }
  } })),
  removeMedicine: (i) => r((e) => ({ prescriptionRequest: {
    ...e.prescriptionRequest,
    prescriptionRequest: {
      ...e.prescriptionRequest.prescriptionRequest,
      medicines: e.prescriptionRequest.prescriptionRequest.medicines.filter((t) => t.pharmaCode !== i)
    }
  } })),
  setPermanentPrescription: (i) => r((e) => ({ prescriptionRequest: {
    ...e.prescriptionRequest,
    prescriptionRequest: {
      ...e.prescriptionRequest.prescriptionRequest,
      permanentPrescription: i
    }
  } })),
  setDeliveryType: (i) => r((e) => ({ prescriptionRequest: {
    ...e.prescriptionRequest,
    prescriptionRequest: {
      ...e.prescriptionRequest.prescriptionRequest,
      deliveryType: i
    }
  } })),
  setDoctorPreferences: (i) => r((e) => ({ prescriptionRequest: {
    ...e.prescriptionRequest,
    doctorPreferences: i
  } })),
  setIntendedType: (i) => r((e) => ({ prescriptionRequest: {
    ...e.prescriptionRequest,
    prescriptionRequest: {
      ...e.prescriptionRequest.prescriptionRequest,
      intendedType: i
    }
  } })),
  setMedicineQuantity: (i) => r((e) => ({ prescriptionRequest: {
    ...e.prescriptionRequest,
    prescriptionRequest: {
      ...e.prescriptionRequest.prescriptionRequest,
      medicines: e.prescriptionRequest.prescriptionRequest.medicines.map((t) => t.pharmaCode === i.pharmaCode ? {
        ...t,
        quantity: i.quantity
      } : t)
    }
  } })),
  setMedicineGenericDrugSelected: (i) => r((e) => ({ prescriptionRequest: {
    ...e.prescriptionRequest,
    prescriptionRequest: {
      ...e.prescriptionRequest.prescriptionRequest,
      medicines: e.prescriptionRequest.prescriptionRequest.medicines.map((t) => t.pharmaCode !== i.pharmaCode || !t.genericDrug ? t : {
        ...t,
        genericDrugSelected: i.genericDrugSelected
      })
    }
  } })),
  clearRequestData: () => r({ prescriptionRequest: p })
});
export {
  s as createPrescriptionRequestActions,
  p as initialPrescriptionRequestState
};

//# sourceMappingURL=prescriptionRequest.action.js.map